<template>
  <ul class="menu-nav">
    <template v-for="item in this.currentUser.menu">
      <router-link
        :key="item.page"
        :to="item.page"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :style="!isActive || item.submenu ? 'display:none' : ''"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> {{ item.title }} </span>
          </a>
        </li>
      </router-link>
      <router-link
        v-for="subitem in item.submenu"
        :to="subitem.page"
        :key="subitem.page"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :style="
            !hasActiveParent(item.page) || subitem.submenu ? 'display:none' : ''
          "
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> {{ subitem.title }} </span>
          </a>
        </li>
      </router-link>
    </template>
  </ul>
</template>

<script>
//import menu_config from "@/core/config/menu.config.json";
import { mapGetters } from "vuex";
export default {
  name: "KTMenu",
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    hasActiveParent(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
